import type { ReactNode } from "react";
import type { Block } from "./types.js";

/**
 * Constructors rather than object literals at every call site.
 *
 * Eighteen topics writing `{ kind: "p", body: ... }` by hand is eighteen
 * chances to typo a discriminant into a block that renders as nothing. A
 * function gets that wrong once, at compile time.
 */
export const p = (body: ReactNode): Block => ({ kind: "p", body });

/** Supporting detail: smaller and muted. Use for caveats, not for the claim. */
export const note = (body: ReactNode): Block => ({ kind: "note", body });

export const ul = (items: readonly ReactNode[]): Block => ({ kind: "ul", items });

export const table = (
  caption: string,
  head: readonly string[],
  rows: readonly (readonly ReactNode[])[],
): Block => ({ kind: "table", caption, head, rows });
